/**
 * PsicoSalud — Internacionalización.
 *
 * El sistema opera en español por defecto y ofrece guaraní como segundo
 * idioma, conforme al carácter bilingüe del Paraguay.
 *
 * El catálogo guaraní es parcial y está marcado como tal en su `_meta`:
 * las claves ausentes recaen en español mediante `fallbackLng`. Es una
 * decisión deliberada — una traducción clínica incorrecta es peor que
 * mostrar el término en español — y permite completar el catálogo de
 * forma incremental sin tocar el código de las vistas.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import gn from './locales/gn.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'es', label: 'Español' },
  { code: 'gn', label: 'Guaraní' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      gn: { translation: gn },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    // Sin esta bandera, una clave vacía en guaraní se mostraría en
    // blanco en lugar de recaer en el español.
    returnEmptyString: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'psicosalud.language',
      caches: ['localStorage'],
    },
  });

export default i18n;
